import script from "./UBO2.vue?vue&type=script&setup=true&lang=js"
export * from "./UBO2.vue?vue&type=script&setup=true&lang=js"

import "./UBO2.vue?vue&type=style&index=0&id=63f70ef3&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63f70ef3"]])

export default __exports__